import { render, staticRenderFns } from "./AdminEstimates.vue?vue&type=template&id=06736f62&scoped=true&"
import script from "./AdminEstimates.vue?vue&type=script&lang=js&"
export * from "./AdminEstimates.vue?vue&type=script&lang=js&"
import style0 from "./AdminEstimates.vue?vue&type=style&index=0&id=06736f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06736f62",
  null
  
)

export default component.exports